import { ReturnOfGOodsFromCustomersService } from "./../../../services/documents/ReturnOfGoodsFromCustomersService";
import { ReturnOfGoodsFromCustomersDetail } from "./../../../components/Pages/Documents/ReturnOfGoodsFromCustomers/ReturnOfGoodsFromCustomersDetail";
import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { CreateReturnOfGoodsFromCustomersDto } from "../../../dtos/documents/ReturnOfGoodsFromCustomers/CreateReturnOfGoodsFromCustomersDto";
import ReturnOfGoodsFromCustomersList from "../../../components/Pages/Documents/ReturnOfGoodsFromCustomers/ReturnOfGoodsFromCustomersList";

export const ReturnOfGoodsFromCustomers: IAppEntity = {
  entityType: "document",
  title: "Return Of Goods From Customers",
  pluralTitle: "Return Of Goods From Customers",
  apiUrl: "ReturnOfGoodsFromCustomers",
  apiEnum: ReferenceTypes.DocumentEmployeeDismissal,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(ReturnOfGoodsFromCustomersDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ReturnOfGoodsFromCustomersList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getDataService: () =>
    new ReturnOfGOodsFromCustomersService("ReturnOfGoodsFromCustomers"),
  getEmptyModel: () => {
    const model: CreateReturnOfGoodsFromCustomersDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      
      documentDate: new Date(),
      createdDate: new Date(),
      returnOfGoodsFromCustomerGoods: [],
    };
    return model;
  },
};
